<template>
  <div>
    <div class="row">
      <div
        v-for="comp in infoComps"
        :key="`comp-${comp.title + comp.subtitle}`"
        class="col-xl-3"
      >
        <b-overlay :show="!comp.loaded" opacity="0.1">
          <CountInfo
            :title="comp.title"
            :subtitle="comp.subtitle"
            :background="comp.background"
            :loaded="comp.loaded"
            :dir="comp.dir"
            :bodyClass="comp.bodyClass"
            :titleClass="comp.titleClass"
            :subtitleClass="comp.subtitleClass"
          ></CountInfo>
        </b-overlay>
      </div>
    </div>
    <div v-if="showChart" class="row">
      <div class="col-sm-12">
        <div class="card card-custom gutter-b">
          <div class="card-header min-h-50px">
            <div class="card-title">
              <h3 class="card-label">نمودار پخش ها</h3>
            </div>
          </div>
          <div class="card-body">
            <VueApexCharts
              height="300px"
              dir="ltr"
              type="line"
              :options="chartOptions"
              :series="chartSeries"
            >
            </VueApexCharts>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { SET_ACTIONS } from "@/core/services/store/actions.module";
import { mapGetters } from "vuex";
import CountInfo from "@/view/content/widgets/stats/CountInfo.vue";
import { FETCH_COMPANY_STATICS } from "@/core/services/store/company/statics.module";
import VueApexCharts from "vue-apexcharts";

export default {
  name: "company-dashboard",
  components: {
    CountInfo,
    VueApexCharts
  },
  data() {
    return {
      interval: null,
      staticsLoaded: false,
      showChart: false,
      chartOptions: {
        stroke: {
          curve: "smooth"
        },
        grid: {
          row: {
            colors: ["#f3f3f3", "transparent"],
            opacity: 0.5
          }
        },
        colors: ["#4554a0"],
        dataLabels: {
          enabled: false
        },
        title: {
          text: ""
        },
        toolbar: {
          show: false
        },
        xaxis: {
          type: "category",
          labels: {
            rotate: -10,
            offsetY: 15,
            style: {
              cssClass: "font-family-serif"
            },
            formatter: function(value) {
              return value?.substring(0, 5);
            }
          },
          categories: []
        },
        yaxis: {
          title: {
            text: "تعداد پخش"
          }
        }
      },
      chartSeries: []
    };
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      {
        title: this.currentUserProperty.title ?? "داشبورد شرکت"
      }
    ]);
    this.$store.dispatch(SET_ACTIONS, {});
    this.getStatics();
    this.interval = setInterval(this.getStatics, 30000);
  },
  destroyed() {
    clearInterval(this.interval);
    this.interval = null;
  },
  computed: {
    ...mapGetters([
      "currentUserProperty",
      "companyStatics",
      "companyLives",
      "companyLivesPagination"
    ]),
    infoComps() {
      return [
        {
          title: this.companyStatics.users
            ? this.companyStatics.users.toString()
            : "0",
          loaded: this.staticsLoaded,
          subtitle: "کاربران",
          bodyClass: "bg-primary",
          titleClass: "text-white",
          subtitleClass: "text-white"
        },
        {
          title: this.companyStatics.destinations
            ? this.companyStatics.destinations.toString()
            : "0",
          loaded: this.staticsLoaded,
          subtitle: "مقصد‌ها",
          bodyClass: "bg-success",
          titleClass: "text-white",
          subtitleClass: "text-white"
        },
        {
          title: this.companyStatics.programs
            ? this.companyStatics.programs.toString()
            : "0",
          loaded: this.staticsLoaded,
          subtitle: "برنامه‌‌ها",
          bodyClass: "bg-secondary font-family-base",
          titleClass: "text-white",
          subtitleClass: "text-white"
        },
        {
          title: this.companyStatics.active_lives
            ? this.companyStatics.active_lives.toString()
            : "0",
          loaded: this.staticsLoaded,
          subtitle: "لایوهای فعال",
          bodyClass: "bg-warning",
          titleClass: "text-white",
          subtitleClass: "text-white"
        }
      ];
    }
  },
  methods: {
    updateChart() {
      let data = [];
      let categories = [];
      this.companyStatics?.stat_lives?.forEach(item => {
        data.push(item.stats.started);
        categories.push(new Date(item.date).toTimeString());
      });

      if (data.length) {
        this.chartOptions.xaxis.categories = categories;
        this.chartSeries = [
          {
            name: "تعداد",
            data: data
          }
        ];

        this.showChart = true;
      }
    },
    getStatics() {
      this.staticsLoaded = false;
      this.$store
        .dispatch(FETCH_COMPANY_STATICS)
        .then(() => {
          this.staticsLoaded = true;
          this.updateChart();
        })
        .catch(() => {
          this.staticsLoaded = true;
        });
    }
  }
};
</script>
